export const ACTIVE_HOTEL_ZOOM = 16;
